import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

/**
 * Shown under a list whose row count has reached the server cap, so the
 * remaining rows are never *silently* invisible (REVIEW finding F-027).
 * Render only when `count >= cap`.
 */
export function ListTruncationNote({ count, cap }: { count: number; cap: number }) {
  const { t } = useTranslation();
  if (count < cap) return null;
  return (
    <div className="flex items-center gap-2 px-5 py-3 text-xs text-muted-foreground border-t border-border">
      <Info size={14} className="shrink-0" aria-hidden />
      <span>{t('common.listTruncated', { count: cap })}</span>
    </div>
  );
}
